module.exports = self["jQuery"];